import { renderTimeNumber } from 'components/forms/DurationInput';
import { InfoPopup } from 'components/popup/InfoPopup';
import { TimeSpan } from 'utils/TimeSpan';

export const UnacknowledgedPeriodInfoPopup = () => (
    <InfoPopup title="Unacknowledged Period" type="info">
        The period of time an alert can go unacknowledged before a notification is sent
    </InfoPopup>
);

export const timespanAsUnacknowledgedPeriodString = (time: TimeSpan) =>
    `${time.days}d ${renderTimeNumber(time.hours)}h ${renderTimeNumber(time.minutes)}m`;
